import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var Scenario;
(function (Scenario) {
    let Flags;
    (function (Flags) {
        Flags[Flags["ACTIVE_INVERTED"] = 8] = "ACTIVE_INVERTED";
    })(Flags = Scenario.Flags || (Scenario.Flags = {}));
    let Type;
    (function (Type) {
        Type[Type["LINEAR"] = 0] = "LINEAR";
        Type[Type["CONDITIONAL"] = 1] = "CONDITIONAL";
        Type[Type["LOOP"] = 2] = "LOOP";
    })(Type = Scenario.Type || (Scenario.Type = {}));
    function isActive(scenario) {
        //поскольку фича появилась позже сценариев, инвертируем состояние,
        //чтобы у всех пользователей сценарии остались включены
        return !isFlagSet(scenario, Flags.ACTIVE_INVERTED);
    }
    Scenario.isActive = isActive;
    function setActive(scenario, enabled) {
        return setFlag(scenario, Flags.ACTIVE_INVERTED, !enabled);
    }
    Scenario.setActive = setActive;
    function getType(scenario) {
        return scenario.setting_register & 0x3;
    }
    Scenario.getType = getType;
    function setType(scenario, type) {
        return {
            ...scenario,
            setting_register: (scenario.setting_register & ~0x3) | type,
        };
    }
    Scenario.setType = setType;
    function changeScenarioType(scenario, type, changes) {
        switch (type) {
            case Scenario.Type.LINEAR:
                return {
                    ...Scenario.setType(scenario, Type.LINEAR),
                    ...changes,
                    loop_time: 0,
                };
            case Scenario.Type.CONDITIONAL:
                return {
                    ...Scenario.setType(scenario, Type.CONDITIONAL),
                    //Может прийти с расписанием, поэтому оставляю возможность перетереть
                    ...changes,
                    timetable: { checked: false, weekday_register: 0, time: 0 },
                    loop_time: 0,
                };
            case Scenario.Type.LOOP:
                return {
                    ...Scenario.setType(scenario, Type.LOOP),
                    ...changes,
                    timetable: { checked: false, weekday_register: 0, time: 0 },
                };
        }
    }
    Scenario.changeScenarioType = changeScenarioType;
    Scenario.get = createAccessors(arrayGetSet('scenarios'), {
        name: 'Новый сценарий',
        links: [],
        timetable: {
            checked: false,
            weekday_register: 0,
            time: 0,
        },
        setting_register: 0,
        loop_time: 0,
    });
})(Scenario || (Scenario = {}));
